"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _addressValidator = _interopRequireDefault(require("./address-validator"));
var _constructedForm2 = _interopRequireDefault(require("./constructed-form.props/constructed-form.defaultProps"));
var _constructedForm3 = _interopRequireDefault(require("./constructed-form.props/constructed-form.propTypes"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /**
 * ## TextField - component
 *
 * A text form element that can take a text type.
 */ // We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var TextField = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(TextField, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existance
  TextField.resourceType = function resourceType() {
    return 'TextField_1_0_0';
  };
  TextField.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var isOverField = state.isOverField,
      overFieldDisabled = state.overFieldDisabled;
    if (props.value !== '' && props.value !== null && isOverField && !overFieldDisabled) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isOverField: false
      });
    }
    return null;
  };
  function TextField(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var overFieldDisabled = props.data.inputType === 'textarea' || props.value !== '' && props.data.fieldName !== 'chosen-test-drive-vehicle' && props.value !== null;
    var isOverField = props.data.fieldName === 'chosen-test-drive-vehicle' && props.value !== '' ? false : !overFieldDisabled;
    _this.state = {
      overFieldDisabled: overFieldDisabled,
      isOverField: isOverField
    };
    _this.handleInputFocus = _this.handleInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleInputBlur = _this.handleInputBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateParent = _this.updateParent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateGoogleParent = _this.updateGoogleParent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.textField = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  var _proto = TextField.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var isOverField = this.state.isOverField;
    var _this$props = this.props,
      value = _this$props.value,
      errorMessages = _this$props.errorMessages;
    return nextProps.value !== value || !this.isSameArray(nextProps.errorMessages, errorMessages) || nextState.isOverField !== isOverField;
  };
  _proto.handleInputFocus = function handleInputFocus() {
    var overFieldDisabled = this.state.overFieldDisabled;
    if (!overFieldDisabled) {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        isOverField: false
      }));
    }
  };
  _proto.handleInputBlur = function handleInputBlur(idx) {
    var _this2 = this;
    return function (e) {
      var overFieldDisabled = _this2.state.overFieldDisabled;
      var handleFieldBlur = _this2.props.handleFieldBlur;
      var errors = _this2.validate(e.target.value, idx);
      if (!e.target.value && !overFieldDisabled) {
        _this2.setState(function () {
          return {
            isOverField: true
          };
        });
      }
      if (handleFieldBlur) {
        handleFieldBlur(e.target.value, idx, errors);
      }
    };
  };
  _proto.getMaxLength = function getMaxLength(maxLength) {
    var upperNum = 5000;
    return maxLength ? "" + Math.min(parseInt(maxLength, 10), upperNum) : '255';
  };
  _proto.getErrors = function getErrors(errorMessages) {
    return errorMessages.filter(function (error) {
      return error !== '';
    });
  };
  _proto.validate = function validate(value, idx) {
    var _this$props2 = this.props,
      checkRequired = _this$props2.checkRequired,
      validateAllConstraints = _this$props2.validateAllConstraints,
      updateErrors = _this$props2.updateErrors,
      _this$props2$data = _this$props2.data,
      isRequired = _this$props2$data.isRequired,
      constraints = _this$props2$data.constraints;
    var errors = [];
    var required = checkRequired(value, isRequired);
    if (value !== '') {
      errors = validateAllConstraints(value, constraints);
    }
    updateErrors(idx, [required].concat(errors));
    return [required].concat(errors);
  };
  _proto.updateParent = function updateParent(idx, fieldName) {
    var _this3 = this;
    return function (e) {
      var handleFieldChange = _this3.props.handleFieldChange;
      _this3.validate(e.target.value, idx);
      handleFieldChange(idx, e.target.value, fieldName);
    };
  };
  _proto.updateGoogleParent = function updateGoogleParent(idx, fieldName, address, isValidationUpdate, isValid) {
    if (isValidationUpdate === void 0) {
      isValidationUpdate = false;
    }
    if (isValid === void 0) {
      isValid = false;
    }
    var handleFieldChange = this.props.handleFieldChange;
    if (isValidationUpdate) {
      // This is a validation state update, not a value change
      // We need to communicate the validation state to the parent
      // For now, we'll call handleFieldChange with the current value and a special flag
      handleFieldChange(idx, address, fieldName, true, isValid);
      console.log("test1", idx, address, fieldName, true, isValid);
    } else {
      // This is a regular value change
      //this.validate(address, idx);
      console.log("test2", idx, address, fieldName);
    }
  }

  // updateGoogleParent(idx, fieldName, address) {
  //     const { handleFieldChange } = this.props;
  //     this.validate(address, idx);
  //     handleFieldChange(idx, address, fieldName);
  // }
  ;
  _proto.checkErrors = function checkErrors(errors) {
    return errors.length > 0;
  }

  // Consider moving this up to constructed-form and passing it back down
  ;
  _proto.isSameArray = function isSameArray(xs, ys) {
    return xs.length === ys.length ? xs.filter(function (x, i) {
      return x !== ys[i];
    }).length === 0 : false;
  };
  _proto.renderInput = function renderInput(inputId) {
    var _this$props3 = this.props,
      theme = _this$props3.theme,
      errorMessages = _this$props3.errorMessages,
      value = _this$props3.value,
      id = _this$props3.id,
      _this$props3$data = _this$props3.data,
      fieldName = _this$props3$data.fieldName,
      inputType = _this$props3$data.inputType,
      isRequired = _this$props3$data.isRequired,
      numberOfLines = _this$props3$data.numberOfLines,
      maxLength = _this$props3$data.maxLength,
      readOnly = _this$props3$data.readOnly,
      addGoogleAddressApiInput = _this$props3$data.addGoogleAddressApiInput,
      _this$props3$config = _this$props3.config,
      market = _this$props3$config.market,
      language = _this$props3$config.language,
      path = _this$props3$config.path;
    var addressValidation = this.state.addressValidation;
    var error = this.getErrors(errorMessages);
    var constraintError = error.length > 0 && error[0] !== 'requiredMessage';
    if (inputType === 'textarea') {
      return /*#__PURE__*/_react["default"].createElement("textarea", {
        ref: this.textField,
        className: theme.inputsAndOptions + " " + _constructedForm["default"].textarea + " " + (this.checkErrors(error) ? _constructedForm["default"].error : ''),
        name: fieldName,
        id: fieldName + "-" + inputId,
        value: value || '',
        required: isRequired,
        "aria-describedby": this.checkErrors(error) && fieldName + "-error-" + id.join('-'),
        "aria-invalid": constraintError,
        cols: "30",
        maxLength: this.getMaxLength(maxLength),
        type: inputType,
        rows: numberOfLines,
        onBlur: this.handleInputBlur(id),
        onFocus: this.handleInputFocus,
        onChange: this.updateParent(id, fieldName),
        readOnly: readOnly
      });
    }
    if (addGoogleAddressApiInput) {
      return /*#__PURE__*/_react["default"].createElement(_addressValidator["default"], {
        ref: this.textField,
        identify: id,
        market: market,
        defaultLang: language,
        path: path,
        className: theme.inputsAndOptions + " " + _constructedForm["default"].textField + " " + (this.checkErrors(error) ? _constructedForm["default"].error : ''),
        theme: theme,
        fieldName: fieldName,
        readOnly: readOnly,
        disabled: fieldName === 'accessory' && value,
        id: fieldName + "-" + inputId,
        type: inputType,
        value: value || '',
        required: isRequired,
        "aria-describedby": this.checkErrors(error) && fieldName + "-error-" + id.join('-'),
        errorMessages: errorMessages,
        constraintError: constraintError,
        onBlur: this.handleInputBlur(id),
        onFocus: this.handleInputFocus,
        onChange: this.updateGoogleParent
      });
    }
    return /*#__PURE__*/_react["default"].createElement("input", {
      ref: this.textField,
      className: theme.inputsAndOptions + " " + _constructedForm["default"].textField + " " + (this.checkErrors(error) ? _constructedForm["default"].error : ''),
      name: fieldName,
      readOnly: readOnly,
      disabled: fieldName === 'accessory' && value,
      id: fieldName + "-" + inputId,
      type: inputType,
      value: value || '',
      required: isRequired,
      "aria-describedby": this.checkErrors(error) && fieldName + "-error-" + id.join('-'),
      "aria-invalid": constraintError,
      onBlur: this.handleInputBlur(id),
      onFocus: this.handleInputFocus,
      onChange: this.updateParent(id, fieldName)
    });
  };
  _proto.render = function render() {
    var _clsx;
    var isOverField = this.state.isOverField;
    var _this$props4 = this.props,
      theme = _this$props4.theme,
      _this$props4$errorMes = _this$props4.errorMessages,
      errorMessages = _this$props4$errorMes === void 0 ? [''] : _this$props4$errorMes,
      id = _this$props4.id,
      _this$props4$data = _this$props4.data,
      fieldName = _this$props4$data.fieldName,
      fieldLabel = _this$props4$data.fieldLabel,
      requiredMessage = _this$props4$data.requiredMessage,
      isRequired = _this$props4$data.isRequired,
      isCaNewsLetterSignUp = _this$props4.isCaNewsLetterSignUp;
    var randomIdModifier = 999;
    var inputId = Math.floor(Math.random() * randomIdModifier);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_constructedForm["default"].formField, (_clsx = {}, _clsx[_constructedForm["default"].caNewsLetterFormField] = isCaNewsLetterSignUp, _clsx[_constructedForm["default"].offScreenElement] = fieldName === 'honeyPot', _clsx)),
      key: fieldName
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: fieldName + "-" + inputId,
      className: _constructedForm["default"].fieldLabel + " " + theme.labelSmall + " " + (isOverField ? _constructedForm["default"].isOverField : '')
    }, fieldLabel && fieldLabel.trim(), isRequired && /*#__PURE__*/_react["default"].createElement("span", {
      className: _constructedForm["default"].requiredNotification
    }, "*")), this.renderInput(inputId), errorMessages[0] === 'requiredMessage' ? /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
      message: requiredMessage,
      theme: theme,
      errorLabel: fieldName + "-error-" + id.join('-'),
      role: "alert"
    }) : errorMessages.filter(function (error) {
      return error !== '';
    }).map(function (message, i) {
      return /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
        key: i,
        message: message,
        theme: theme,
        errorLabel: fieldName + "-error-" + id.join('-'),
        role: "alert"
      });
    }));
  };
  return TextField;
}(_react["default"].Component);
exports["default"] = TextField;
TextField.displayName = 'TextField';
TextField.defaultProps = {
  data: _constructedForm2["default"].formComponents[6],
  // eslint-disable-line
  theme: {}
};